import { render, staticRenderFns } from "./LearnerHistory.vue?vue&type=template&id=79ef8846"
import script from "./LearnerHistory.vue?vue&type=script&lang=js"
export * from "./LearnerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports